import React from 'react'
import styled from 'styled-components'
import ParseContent from 'components/shared/ParseContent'
import ButtonDefault from 'components/elements/ButtonDefault'

const StyledTextBlockWithLabel = styled.section`
  position: relative;
  z-index: 1;
  padding-top: 150px;
  padding-bottom: 150px;

  @media screen and (max-width: 991px) {
    padding-top: 60px;
    padding-bottom: 60px;
  }
`

const StyledContainer = styled.div`
  height: 100%;

  @media screen and (max-width: 991px) {
    height: unset;
    position: relative;
  }
`

const StyledBox = styled.div`
  background-color: ${(props) => props.theme.color.face.light};
  height: 100%;
  width: 100%;
  border-radius: 20px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
  padding: 60px;
  display: flex;
  flex-direction: row;
  
  & > div {
    width: 50%;
  }

  @media screen and (min-width: 992px) {
    gap: 30px;
  }

  @media screen and (max-width: 991px) {
    flex-direction: column;
    padding: 40px 24px;
    gap: 10px;

    & > div {
      width: 100%;
    }
  }
`

const StyleShadow = styled.div`
  background: ${(props) => props.theme.color.gradient.main};
  position: absolute;
  height: 100%;
  width: 100%;
  top: -40px;
  left: -40px;
  z-index: -1;
  border-radius: 20px;

  @media screen and (max-width: 991px) {
    top: -10px;
    left: -10px;
  }
`

const Wrapper = styled.div``
const BoxColumn = styled.div`
  & h2 {
    font-weight: ${(props) => props.theme.font.weight.xl};

    @media screen and (min-width: 992px) {
      font-size: ${(props) => props.theme.font.size.xl};
    }

    @media screen and (max-width: 991px) {
      font-size: ${(props) => props.theme.font.size.l};
    }
  }
`
const Subtitle = styled.div`
  background: ${(props) => props.theme.color.gradient.main};
  font-size: ${(props) => props.theme.font.size.s};
  color: ${(props) => props.theme.color.text.light};
  padding: 3px 10px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 6px;

  &:before {
    content: '';
    position: relative;
    display: block;
    height: 5px;
    width: 5px;
    background: ${(props) => props.theme.color.text.light};
    border-radius: 100%;
  }
`
const BoxColumnRight = styled.div``
const ButtonBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media screen and (max-width: 575px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const ButtonWrapper = styled.div`
  @media screen and (max-width: 575px) {
    width: 100%;

    & > * {
      width: 100%;
      display: block;
      text-align: center;
    }
  }
`
const Microcopy = styled.div`
  font-size: ${(props) => props.theme.font.size.s};
  color: ${(props) => props.theme.color.text.dark};

  @media screen and (max-width: 575px) {
    align-self: center;
    text-align: center;
  }
`

const TextBlockWithLabel = ({ className = '', content, id = 'text-block-with-label' }) => {
  if (!content) return null
  return (
    <StyledTextBlockWithLabel id={id} className={`${className}`}>
      <StyledContainer className="container">
        <Wrapper className="position-relative">
          <StyledBox>
            <BoxColumn>
              <div className="d-flex mb-3">
                <Subtitle>{content?.subtitle}</Subtitle>
              </div>
              <h2>{content?.title}</h2>
            </BoxColumn>
            <BoxColumnRight>
              <div className="pb-3">
                <ParseContent
                  content={content?.description}
                  compactLineHeight
                />
              </div>
              <ButtonBlock>
                <ButtonWrapper>
                  <ButtonDefault icon="arrow" to={content?.link?.url}>
                    {content?.link?.title}
                  </ButtonDefault>
                </ButtonWrapper>
                <Microcopy>{content?.microcopy}</Microcopy>
              </ButtonBlock>
            </BoxColumnRight>
          </StyledBox>
          <StyleShadow />
        </Wrapper>
      </StyledContainer>
    </StyledTextBlockWithLabel>
  )
}

export default TextBlockWithLabel
